import { List } from "antd";
import { NotificationListItemProps } from ".";
import { IoIosWarning } from "react-icons/io";
import { StyledNotifyListItem } from "./index.styled";
import { useNotification } from "@lib/hooks/useNotification";
import { useTypedSelector } from "@lib/redux";
import { useIntl } from "react-intl";

export default function UnknownEvent(props: NotificationListItemProps) {
  const { notification } = props;
  const { messages } = useIntl();
  const { role } = useTypedSelector((state) => state.auth?.user);
  const { handleClick } = useNotification({
    role,
    initialNotification: notification,
    messages,
  });

  return (
    <StyledNotifyListItem className="item-hover" onClick={handleClick}>
      <List.Item.Meta
        title={`Unknown event: ${notification.event}`}
        avatar={<IoIosWarning />}
      />
    </StyledNotifyListItem>
  );
}
